import React from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Price from '../price/Price';

class BasketPhone extends React.Component {

    render() {
        return (
            <React.Fragment>        
                <a href={this.props.settings.links.basketLink}  > 
                    <i className="glyphicon glyphicon-shopping-cart"></i> 
                    <b><Price 
                        valueEUR={this.props.basket.totalPriceWithVat} 
                        valueCZK={this.props.basket.totalPriceCZKWithVat}  
                    /></b> 
                </a>       
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
  basket: state.basket,
  settings: state.settingsReducer
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BasketPhone);